<div [formGroup]="form" [ngClass]="{ 'question-margin': !question.validators.length, hidden: $any(question).hidden }">
    @if (question.question) {
        <div class="flex items-center">
            <h4 class="mb-4">{{ question.question | translate }}</h4>
            @if (question.tooltip) {
                <ca-icon
                    icon="info-outline"
                    class="ca-icon-s-18-p-0-f-18 ms-2 mb-4 cursor-pointer"
                    matTooltipPosition="above"
                    matTooltipClass="ca-tooltip"
                    [matTooltip]="question.tooltip | translate"
                ></ca-icon>
            }
        </div>
    }
    <div class="flex items-center" [class.mb-6]="question.img">
        @if (question.img) {
            <img class="description-img me-4" [src]="question.img" />
        }
        <div>
            @if (question.description) {
                <p class="mb-4">{{ question.description | translate }}</p>
            }
            @if ($any(question).descriptionList) {
                <ul class="mb-4 ps-6">
                    @for (item of $any(question).descriptionList; track trackBySelf($index, item)) {
                        <li>
                            {{ item | translate }}
                        </li>
                    }
                </ul>
            }
            @if (question.bottomDescription) {
                <p class="mb-4">{{ question.bottomDescription | translate }}</p>
            }
        </div>
        @if (question.content) {
            <div class="mb-6"><ng-template vpViewHost></ng-template></div>
        }
    </div>
    <div>
        @switch ($any(question).controlType) {
            @case (CONTROL_TYPES.Textbox) {
                <vp-textbox [question]="question | as: TYPES.TextboxQuestion" [form]="form"></vp-textbox>
            }
            @case (CONTROL_TYPES.Radio) {
                <vp-radio [question]="question | as: TYPES.RadioQuestion" [form]="form"></vp-radio>
            }
            @case (CONTROL_TYPES.Checkbox) {
                <vp-checkbox [question]="question | as: TYPES.CheckboxQuestion" [form]="form"></vp-checkbox>
            }
            @case (CONTROL_TYPES.CheckboxSet) {
                <vp-checkbox-set [question]="question | as: TYPES.CheckboxSet" [form]="form"></vp-checkbox-set>
            }
            @case (CONTROL_TYPES.MultiTextbox) {
                <vp-multi-textbox [question]="question | as: TYPES.MultiTextbox" [form]="form"></vp-multi-textbox>
            }
            @case (CONTROL_TYPES.MultiQuestionbox) {
                <vp-multi-questionbox [question]="question | as: TYPES.MultiTextbox" [form]="form"></vp-multi-questionbox>
            }
            @case (CONTROL_TYPES.CustomAnswerRadio) {
                <vp-custom-answer-radio [question]="question | as: TYPES.CustomAnswerRadio" [form]="form"> </vp-custom-answer-radio>
            }
            @case (CONTROL_TYPES.Slider) {
                <vp-slider
                    [form]="form"
                    [formControlName]="$any(question).key"
                    [question]="question | as: TYPES.SliderQuestion"
                ></vp-slider>
            }
            @case (CONTROL_TYPES.Dropdown) {
                <vp-dropdown [form]="form" [question]="question | as: TYPES.Dropdown"></vp-dropdown>
            }
            @case (CONTROL_TYPES.SearchDropdown) {
                <vp-search-dropdown
                    [formGroup]="form"
                    [formControlName]="$any(question).key"
                    [question]="question | as: TYPES.SearchDropdown"
                ></vp-search-dropdown>
            }
            @case (CONTROL_TYPES.Addressbox) {
                <vp-addressbox [form]="form" [highlights]="highlights" [question]="question | as: TYPES.Addressbox"></vp-addressbox>
            }
            @case (CONTROL_TYPES.AdvancedSearch) {
                <vp-advanced-search
                    (trigger)="questionTrigger.emit($event)"
                    [form]="form"
                    [question]="question | as: TYPES.AdvancedSearch"
                ></vp-advanced-search>
            }
        }
    </div>
</div>
